import styled from 'styled-components';

export const AntSwitch = (ComponentName: any) => styled(ComponentName)`
  &.ant-switch-checked {
    border-color: #9012F5;
    background-color: #9012F5;
  }
`;
